import { Component, OnInit, Input } from '@angular/core';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-application-progress',
  templateUrl: './application-progress.component.html',
  styleUrls: ['./application-progress.component.scss'],
})
export class ApplicationProgressComponent implements OnInit {

  @Input() stepProgress: StepProgress;
  @Input() isOnAppHomePage?: boolean;

  private allItemsCompleteColor = '#08942E';
  private someItemsLeftColor = '#3246F0';

  constructor(private userService: UserService) { }

  ngOnInit() {}

  get outerStrokeColor() {
    if (!this.stepProgress) return;
    return this.stepProgress.complete === this.stepProgress.total ? this.allItemsCompleteColor : this.someItemsLeftColor;
  }

  get percentProgress() {
    if (!this.stepProgress) return;
    return this.stepProgress.complete / this.stepProgress.total * 100;
  }

  get headerText() {
    if (!this.stepProgress) return;
    return `${this.stepProgress.complete} of ${this.stepProgress.total} items complete`;
  }

  get subHeaderText() {
    if (!this.stepProgress) return;
    if (this.stepProgress.isPendingReview) {
      return "We'll notify you when review is finished";
    }
    if (this.stepProgress.isPendingI9Section2) {
      return `Your employment eligibility is pending the completion of I-9 section 2.
      Schedule a time with your friend or family member to inspect and validate your documents with you in person.
      They will receive an email to complete I-9 Section 2 on their device.`;
    }
    if (this.stepProgress.isPendingBackgroundCheck) {
      return `Most background checks take less than 5 minutes. Sometimes a background check can take days or weeks. 
      We will notify you when your background check is complete.`;
    }
    if (this.userService.isCurrentUserEligible()) {
      return this.isOnAppHomePage ? 'Jobs fill quickly. Complete as soon as possible.' : 'Tap to continue';
    } else {
      return this.isOnAppHomePage ? 'Jobs fill quickly. Complete as soon as possible. You cannot work until all items are complete.'
        : 'Tap to continue';
    }
  }
}

export interface StepProgress {
  total: number;
  complete: number;
  isPendingReview?: boolean;
  isPendingI9Section2?: boolean;
  isPendingBackgroundCheck?: boolean;
}
